import React from 'react';
import LeafMark from './LeafMark';

export default function RefillBadge({ titulo, description }) {
  if (!description) return null;
  return (
    <div style={{
      margin: '0 20px 28px', border: '1px solid rgba(28,58,30,0.14)', borderRadius: 'var(--r-lg)',
      padding: 22, display: 'flex', gap: 16, alignItems: 'flex-start', background: 'rgba(159,190,106,0.06)',
    }}>
      <LeafMark size={26} color="var(--sage)" style={{ flexShrink: 0, marginTop: 2 }} />
      <div>
        <div style={{
          fontFamily: "'AvenirCondensed', var(--font-body)", textTransform: 'uppercase', letterSpacing: 1,
          fontWeight: 700, color: 'var(--forest)', fontSize: 15, marginBottom: 6,
        }}>
          {titulo || 'Sistema Refill Wawita'}
        </div>
        <p style={{ fontSize: 13.5, color: 'var(--ink-light)', margin: 0, lineHeight: 1.7 }}>{description}</p>
      </div>
    </div>
  );
}
